
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.411 14.836l1.078-6.565 1.1 4.726a.506.506 0 00.965.072l.997-2.548.573 1.165s.187.314.498.314H11v-1H9.95l-.956-2.012a.506.506 0 00-.936.016l-.845 2.16L5.91 5.395A.49.49 0 005.42 5a.495.495 0 00-.502.425L3.837 12.09 2.732 7.986c-.123-.49-.814-.519-.972-.032L.939 11H0v.984h1.337a.484.484 0 00.433-.323l.466-1.506 1.187 4.723c.133.533.9.498.988-.042zM24 17.586l-2.831-2.832c.522-.79.831-1.735.831-2.754a5 5 0 10-5 5 4.977 4.977 0 002.755-.832L22.586 19 24 17.586zM14 12c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z"}})])
          )
        }
      }
    